module.exports = __webpack_public_path__ + "static/Artboard-4-926591e92c061ea9515789ced403d5e1.png";